import React from 'react';
import { useFormState } from '../hooks/useFormState.js';

var Debug = function Debug(props) {
  var formState = useFormState();
  var displayState = {};

  if (Object.keys(props).length > 0) {
    Object.keys(props).forEach(function (key) {
      displayState[key] = formState[key];
    });
  } else {
    displayState = formState;
  }

  return /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, JSON.stringify(displayState, null, 2)));
};

export { Debug };
